webpackJsonp([93772435260754],{

/***/ 2539:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/delete-tweet-dialog.e0493d09.png";

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PatternConstruction = __webpack_require__(22);
	
	var _PatternConstruction2 = _interopRequireDefault(_PatternConstruction);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _FormsPatternTutorialBranch = __webpack_require__(41);
	
	var _FormsPatternTutorialBranch2 = _interopRequireDefault(_FormsPatternTutorialBranch);
	
	var _deleteTweetDialog = __webpack_require__(2539);
	
	var _deleteTweetDialog2 = _interopRequireDefault(_deleteTweetDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _PatternConstruction2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      '1. Refactor Delete Dialog'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'ll be refactoring the UpdateTweetDialog to leverage the blueprint we just created.'
	    ),
	    _react2.default.createElement(_FormsPatternTutorialBranch2.default, { branch: 'destroy.1' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Dialog Comparison'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you compare the delete dialog to the original update dialog, you\'ll find that once again, very little is different. In fact, the only code that\'s different is reflected below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      ...\n      propTypes: {\n        tweet: PropTypes.object.isRequired\n      },\n\n      getInitialState() {\n        return {\n          data: {}\n        };\n      },\n\n      request(data) {\n        const { tweet } = this.props;\n        lore.actions.tweet.update(tweet, data);\n      },\n\n      getValidators: function(data) {\n        return {};\n      },\n\n      render() {\n        ...\n        return (\n          <div className="modal-dialog">\n              ...\n                <h4 className="modal-title">\n                  Delete Tweet\n                </h4>\n              ...\n              <div className="modal-body">\n                <div className="row">\n                  <div className="col-md-12">\n                    <p>\n                      Are you sure you want to delete this?\n                    </p>\n                  </div>\n                </div>\n              </div>\n              <div className="modal-footer">\n                ...\n                <button\n                  type="button"\n                  className="btn btn-primary"\n                  disabled={hasError}\n                  onClick={this.onSubmit}\n                >\n                  Delete\n                </button>\n                ...\n              </div>\n              ...\n          </div>\n        );\n      }\n      ..\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this case, the delete dialog is intended to ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'delete a tweet'
	      ),
	      ', and so it requires a prop which is the tweet that should be updated.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The biggest difference is that instead of fields for user input, this form prompts the user with a confirmation question, to double check that they mean to delete the tweet. Once they confirm, and the form is submitted, the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'request()'
	      ),
	      ' method uses the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'delete'
	      ),
	      ' action instead of the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'update'
	      ),
	      ' action.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Also, because the form has no user input fields, the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'getInitialState()'
	      ),
	      ' does not need to set an initial state for the form, and there is no need to specify an validators.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Additionally, (looking at the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'render()'
	      ),
	      ' method) the title of the form is "Delete Tweet" instead of "Update Tweet", and the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'onSubmit'
	      ),
	      ' button says "Delete" instead of "Update".'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Other than that, the forms are identical.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Add Custom Field Type'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Currently, we can solve all of those requirements ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'except'
	      ),
	      ' for inserting custom text into a form. So how do we solve that?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'One way is to think of custom text like the confirmation question as a type of field, but one that allows you to render whatever you want, instead of predetermined "thing", like we do with the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'text'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'select'
	      ),
	      ' fields. And luckily, our current setup will allow us to do that.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To demonstrate how to do this, open ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'config/dialogs.js'
	      ),
	      '. Then find the section that defines the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'fieldMap'
	      ),
	      ', and add a new field type called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'custom'
	      ),
	      ' that looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // config/dialogs.js\n      ...\n      fieldMap: {\n        ...\n        custom: function(form, props, name) {\n          return (\n            <Field key={name} name={name} data={form.data} errors={form.errors} onChange={form.onChange}>\n              {(field) => {\n                return props.render(field, props);\n              }}\n            </Field>\n          );\n        }\n      }\n      ...\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'With that change in place, we can now specify insert ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'custom'
	      ),
	      ' fields into forms, as long as we provide a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'render()'
	      ),
	      ' method as a prop to that field type, we can render whatever we want.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Refactor Delete Dialog'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To see how to use the new field type we just created, open the delete dialog located at ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'src/dialogs/tweet/destroy/index.js'
	      ),
	      ' and replace the contents with the code shown below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import React from \'react\';\n      import createReactClass from \'create-react-class\';\n      import PropTypes from \'prop-types\';\n      import OptimisticBlueprint from \'../../_blueprints/Optimistic\';\n\n      export default createReactClass({\n        displayName: \'DeleteTweetDialog\',\n\n        propTypes: {\n          onCancel: PropTypes.func,\n          tweet: PropTypes.object.isRequired\n        },\n\n        getInitialState() {\n          return {\n            data: {}\n          };\n        },\n\n        request(data) {\n          const { tweet } = this.props;\n          lore.actions.tweet.destroy(tweet);\n        },\n\n        render() {\n          const { data } = this.state;\n          const { schema, fieldMap, actionMap } = lore.config.dialogs;\n\n          return (\n            <OptimisticBlueprint\n              title="Delete Tweet"\n              onCancel={this.props.onCancel}\n              data={data}\n              schema={schema}\n              fieldMap={fieldMap}\n              actionMap={actionMap}\n              request={this.request}\n              validators={function(data) {\n                return {};\n              }}\n              fields={[\n                {\n                  key: \'confirmation\',\n                  type: \'custom\',\n                  props: {\n                    render: (form) => {\n                      return (\n                        <p>\n                          Are you sure you want to delete this?\n                        </p>\n                      );\n                    }\n                  }\n                }\n              ]}\n              actions={[\n                {\n                  key: \'cancel\',\n                  type: \'default\',\n                  props: (form) => {\n                    return {\n                      label: \'Cancel\',\n                      onClick: form.callbacks.dismiss\n                    };\n                  }\n                },\n                {\n                  key: \'submit\',\n                  type: \'primary\',\n                  props: (form) => {\n                    return {\n                      label: \'Delete\',\n                      disabled: form.hasError,\n                      onClick: form.callbacks.onSubmit\n                    };\n                  }\n                }\n              ]}\n            />\n          );\n        }\n\n      });\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Here we\'ve specified one field, of type ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'custom'
	      ),
	      ', and then provided a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'render()'
	      ),
	      ' method via the props we want passed to that component during creation. In this case, the fucntion we defined for the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'custom'
	      ),
	      ' field type looks for that function, and then renders what ever it returns.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, clicking the delete link will still launch a dialog that you can use to delete an existing tweet.'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _deleteTweetDialog2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/dialogs/tweet/destroy/index.js'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import React from \'react\';\n      import createReactClass from \'create-react-class\';\n      import PropTypes from \'prop-types\';\n      import OptimisticBlueprint from \'../../_blueprints/Optimistic\';\n\n      export default createReactClass({\n        displayName: \'DeleteTweetDialog\',\n\n        propTypes: {\n          onCancel: PropTypes.func,\n          tweet: PropTypes.object.isRequired\n        },\n\n        getInitialState() {\n          return {\n            data: {}\n          };\n        },\n\n        request(data) {\n          const { tweet } = this.props;\n          lore.actions.tweet.destroy(tweet);\n        },\n\n        render() {\n          const { data } = this.state;\n          const { schema, fieldMap, actionMap } = lore.config.dialogs;\n\n          return (\n            <OptimisticBlueprint\n              title="Delete Tweet"\n              onCancel={this.props.onCancel}\n              data={data}\n              schema={schema}\n              fieldMap={fieldMap}\n              actionMap={actionMap}\n              request={this.request}\n              validators={function(data) {\n                return {};\n              }}\n              fields={[\n                {\n                  key: \'confirmation\',\n                  type: \'custom\',\n                  props: {\n                    render: (form) => {\n                      return (\n                        <p>\n                          Are you sure you want to delete this?\n                        </p>\n                      );\n                    }\n                  }\n                }\n              ]}\n              actions={[\n                {\n                  key: \'cancel\',\n                  type: \'default\',\n                  props: (form) => {\n                    return {\n                      label: \'Cancel\',\n                      onClick: form.callbacks.dismiss\n                    };\n                  }\n                },\n                {\n                  key: \'submit\',\n                  type: \'primary\',\n                  props: (form) => {\n                    return {\n                      label: \'Delete\',\n                      disabled: form.hasError,\n                      onClick: form.callbacks.onSubmit\n                    };\n                  }\n                }\n              ]}\n            />\n          );\n        }\n\n      });\n      ' }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This step concludes the tutorial. Next we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../../next-steps/' },
	        'discuss next steps'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-forms-pattern-destroy-step-1-js-376434a241394881e02a.js